module.exports = __webpack_public_path__ + "media/images/logo-stack-e006ebcbeb4b48ad75f4d471edac1c3f.svg";